/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import styled from '@themes/theme'
import { ButtonStyles } from '@styles/button.style'
import { LikeIco } from '@shared/Icon/EtcIcon'

export interface LikeButtonProps {
  id?: string
  className?: string
  onClick?: () => void
  hideStyle?: boolean
  count?: number
  disabled?: boolean
}

const PickLikeBtn = styled.button`
  ${ButtonStyles};
  z-index: 0;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 74px;
  height: 45px;
  margin: 8px 0;
  padding: 0 10px 0 4px;
  background: none;
  svg {
    width: 36px;
    height: 36px;
    path {
      fill: ${props => props.theme.color.disableBg};
    }
  }
  .num, .like-num {
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.medium};
    color: ${props => props.theme.color.btn};
  }
  &.active {
    svg .fill {
      fill: ${props => props.theme.color.underover};
    }
  }
  &.pick-bar-btn {
    height: 34px;
  }
  &:not(.pick-bar-btn){
    margin-left: -10px;
  }
`

export const LikeButton: React.FC<LikeButtonProps> = observer((props: LikeButtonProps) => {
  const { id, className, onClick, hideStyle = false, count, disabled = false } = props
  return (
    <PickLikeBtn
      id={id}
      className={className}
      disabled={disabled}
      onClick={() => {
        if (onClick) {
          onClick()
        }
      }}
    >
      {!hideStyle && (
        <Fragment>
          <LikeIco/>
          <span className="num">{count}</span>
        </Fragment>
      )}
    </PickLikeBtn>
  )
})
